import { useTranslation } from 'react-i18next';
// material
// import { enUS, zhCN, zhHK } from '@mui/material/locale';
import { enUS, zhHK, zhCN } from '@mui/material/locale';

// ----------------------------------------------------------------------

const LANGS = [
  {
    label: '中文繁體',
    value: 'zh',
    systemValue: zhHK,
  },
  {
    label: '中文简体',
    value: 'cn',
    systemValue: zhCN,
  },
  {
    label: 'English',
    value: 'english',
    systemValue: enUS,
  },
];

export default function useLocales() {
  const { i18n, t } = useTranslation();

  // set default lang

  const langStorage = localStorage.getItem('lang');
  const currentLang =
    LANGS.find((_lang) => _lang.value === langStorage) || 'zh';
  const handleChangeLanguage = (newlang) => {
    i18n.changeLanguage(newlang);
  };

  return {
    onChangeLang: handleChangeLanguage,
    t,
    currentLang,
  };
}
